import CartingRequest from './CartingRequest';

export default class EmptyRequest extends CartingRequest {
  public toJSON(): void {
    // empty toJSON method
  }
}
